var the_map;
var bounds;
var route;
var initialLine;
var marks;
var addMenu;
var markerMenus;
var distanceLables;
var legDis;

function intiateMap(canvas){
// function intiateMap(){
//     canvas = 'map-canvas';
    marks = [];
    markerMenus = [];
    route = [];
    distanceLables = [];
    legDis = [];
    var mapCanvas = document.getElementById(canvas);
    var mapOptions = {
        center: new google.maps.LatLng(0,0),
        zoom: 2,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        streetViewControl: false,
        panControl: false,
        zoomControl: true,
        zoomControlOptions: {
          style: google.maps.ZoomControlStyle.LAREGE,
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        }
    };
    bounds = new google.maps.LatLngBounds();
    the_map = new google.maps.Map(mapCanvas, mapOptions);
    // initialisecContextMenu();
}

function panZoom(lat, lng){
    the_map.panTo(new google.maps.LatLng(lat, lng));
    the_map.setZoom(5);
}

function resetMap(){
    removeLines();
    clearMarks();
    the_map.panTo(new google.maps.LatLng(0, 0));
    the_map.setZoom(2);
    bounds = new google.maps.LatLngBounds();
}

function removeLines(){
    /*if(route){
        route.setMap(null);
    }*/
    for(i=0;i<route.length;i++){
        route[i].setMap(null);
    }
    route = [];
    removeDirections();
    //initialLine = true;
}

function clearMarks(){
    for(i=0;i<marks.length;i++){
        marks[i].setMap(null);
    }
    marks = [];
    makerMenus = [];
    distanceLables = [];
    legDis = [];
}

function hideOtherMenus(){
    addMenu.hide();
    for(i=0;i<markerMenus.length;i++){
        markerMenus[i].hide();
    }
}

function addMarker(data){
    var position = new google.maps.LatLng(data.lat, data.lng);
    var marker = new google.maps.Marker({
        position: position,
        map: the_map,
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 1,
          fillColor: 'red',
          fillOpacity: 1,
          strokeColor: 'red'
        },
        title: data.formatted
    });
    bounds.extend(marker.position);
    the_map.fitBounds(bounds);
    the_map.panToBounds(bounds);
    marks.push(marker);
    var contextMenuOptions={};
	contextMenuOptions.classNames={menu:'context_menu marker_menu', menuSeparator:'context_menu_separator'};
	var menuItems=[];
	menuItems.push({className:'context_menu_item', eventName:'delete_click', id:'deleteItem', label:'Delete Location'});
	contextMenuOptions.menuItems=menuItems;

	// var pos = markerMenus.push(new ContextMenu(the_map, contextMenuOptions)) - 1;
	
	// google.maps.event.addListener(marker, 'rightclick', function(mouseEvent){
	//     hideOtherMenus();
	// 	markerMenus[pos].show(mouseEvent.latLng);
	// });
	
	// google.maps.event.addListener(markerMenus[pos], 'menu_item_selected', function(latLng, eventName){
	// 	switch(eventName){
	// 		case 'delete_click':
	// 		    var cont = running;
 //                running = false;
 //                removeLines();
 //                removePoint(marker.title, '#start', '#end', '#waypoints');
 //                marker.setMap(null);
 //                if(cont){
 //                    resetMap();
 //                    algorithmReset();
 //                    optimisied = true;
 //                    geoCode('#start', '#end', '#waypoints');
 //                }
	// 			break;
	// 	}
	// });
}

function printSegment(leg){
  console.log(leg);
}

function addPolyLine() {
    var routeCoordinates = [];
    for(i=0;i<best.length;i++){
        if(points[best[i]].formatted!='CoE'){
            routeCoordinates.push({latLng: new google.maps.LatLng(points[best[i]].lat, points[best[i]].lng), x: points[best[i]].x, y: points[best[i]].y, z: points[best[i]].z});
            }
    }
    removeLines();
    for(var i=0;i<routeCoordinates.length-1;i++){
        var tempCoords = [];
        tempCoords.push(routeCoordinates[i].latLng);
        tempCoords.push(routeCoordinates[i+1].latLng);
        route.push(new google.maps.Polyline({
            path: tempCoords,
            geodesic: true,
            strokeColor: '#FF0000',
            strokeOpacity: 1.0,
            strokeWeight: 2,
            map: the_map,
            id: i
        }));

        var leg = Math.round((~~distance(routeCoordinates[i], routeCoordinates[i+1])/1000));
        var legFormatted = (leg.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' ' + unitsShort);
        
        var contextMenuOptions={};
	    contextMenuOptions.classNames={menu:'context_menu displance_display', menuSeparator:'context_menu_separator'};
	    var menuItems=[];
	    menuItems.push({className:'context_menu_item', eventName:'distance_click', id:'distanceItem', label: legFormatted});
	    contextMenuOptions.menuItems=menuItems;
	    // var pos = distanceLables.push(new ContextMenu(the_map, contextMenuOptions)) - 1;
	    
     //    bindLabelEvents(route[i], distanceLables[pos]);
      
        google.maps.event.addListener(route[i], 'click', function(mouseEvent){
            if(!running && !tweaking){
              optimiseSegment(this.id);
            }
        });
    }
}

function bindLabelEvents (polyline, label) {
    google.maps.event.addListener(polyline, 'mouseover', function(mouseEvent) {
        label.show(mouseEvent.latLng);
    });

    google.maps.event.addListener(polyline, 'mouseout', function(mouseEvent) {
        label.hide();
    });
}

function fromLatLngToPoint(latLng, the_map) {
	var topRight = the_map.getProjection().fromLatLngToPoint(the_map.getBounds().getNorthEast());
	var bottomLeft = the_map.getProjection().fromLatLngToPoint(the_map.getBounds().getSouthWest());
	var scale = Math.pow(2, the_map.getZoom());
	var worldPoint = the_map.getProjection().fromLatLngToPoint(latLng);
	return new google.maps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale);
}

function initialisecContextMenu(){
	
	var contextMenuOptions={};
	contextMenuOptions.classNames={menu:'context_menu add_menu', menuSeparator:'context_menu_separator'};
	var menuItems=[];
	menuItems.push({className:'context_menu_item', eventName:'directions_origin_click', id:'directionsOriginItem', label:'Add Start Point'});
	menuItems.push({});
	menuItems.push({className:'context_menu_item', eventName:'directions_destination_click', id:'directionsDestinationItem', label:'Add End Point'});
	menuItems.push({});
	menuItems.push({className:'context_menu_item', eventName:'directions_waypoint_click', id:'directionsWaypointItem', label:'Add Waypoint'});
	contextMenuOptions.menuItems=menuItems;
	
	addMenu=new ContextMenu(the_map, contextMenuOptions);
	
	google.maps.event.addListener(the_map, 'rightclick', function(mouseEvent){
	    hideOtherMenus();
		addMenu.show(mouseEvent.latLng);
	});
	
	google.maps.event.addListener(addMenu, 'menu_item_selected', function(latLng, eventName){
		switch(eventName){
			case 'directions_origin_click':
                var cont = running;
                running = false;
                removeLines();
                optimisied = true;
                reverseGeoCode(latLng, '#start', cont);
				break;
			case 'directions_destination_click':
                var cont = running;
                running = false;
                removeLines();
                optimisied = true;
                reverseGeoCode(latLng, '#end', cont);
				break;
			case 'directions_waypoint_click':
                var cont = running;
                running = false;
                removeLines();
                optimisied = true;
                reverseGeoCode(latLng, '#waypoints', cont);
				break;
		}
	});
}
